import React from 'react';
import { Button, Loading, Tag, Toggle } from 'carbon-components-react';
import { Renew16 } from '@carbon/icons-react';
import { useSelector } from 'react-redux';
import {
  selectPausedReferralsCount,
  selectActiveChannelLoading
} from 'redux/channels';

const PauseResumeReferralChannels: React.FC<any> = ({
  handleRenew,
  handleToggleLocal,
  isSendingPaused
}) => {
  const pausedReferralsCount: any = useSelector(selectPausedReferralsCount);
  const loading: any = useSelector(selectActiveChannelLoading);

  return (
    <div className="referral-active-pause-resume">
      <div className="referral-active-pause-resume-sending">
        {'Pause sending'}
      </div>
      <div className="referral-active-pause-resume-caution">
        Caution, pausing will temporarily stop the system from sending you
        enquiry referrals
      </div>
      <hr className="section--divider" />
      <div className="referral-active-pause-resume-toggle-container">
        <div>Pause referrals</div>
        <Toggle
          toggled={isSendingPaused}
          labelText=""
          labelA=""
          labelB=""
          id="referral-active-pause-resume-toggle"
          onToggle={handleToggleLocal}
        />
      </div>
      <hr className="section--divider" />
      {isSendingPaused && (
        <div className="referral-active-pause-resume-pause-referral-container">
          <div className="queued-referral">Queued referrals</div>
          <Button
            className="refresh--btn"
            hasIconOnly
            renderIcon={Renew16}
            tooltipAlignment="center"
            tooltipPosition="bottom"
            iconDescription="Refresh"
            onClick={handleRenew}
            kind="ghost"
          />
          <div className="referral-count">
            {loading ? (
              <Loading
                small
                description="Active loading indicator"
                withOverlay={false}
              />
            ) : (
              <Tag>{pausedReferralsCount}</Tag>
            )}
          </div>
        </div>
      )}
      <div className="referral-active-pause-resume-footer">
        {isSendingPaused
          ? 'Current status is paused'
          : 'Current status is not paused'}
      </div>
    </div>
  );
};
export default PauseResumeReferralChannels;
